module.exports = __webpack_public_path__ + "static/media/31JFA2.e03c238d.jpg";